import React, { useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container" style={{ minHeight: "70vh", paddingTop: "40px", paddingBottom: "40px" }}>
      <Container>
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3" style={{ color: "#760B0B", fontSize: "36px" }}>
            Privacy Policy
          </h1>
          <p className="text-muted" style={{ fontSize: "16px" }}>
            Last Updated: February 2026
          </p>
        </div>

        <Card className="border-0 shadow-lg mb-4" style={{ borderRadius: "20px" }}>
          <Card.Body className="p-5">
            <div style={{ lineHeight: "1.8", color: "#333", textAlign: "left" }}>
              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  1. Introduction
                </h3>
                <p>
                  Welcome to HostelDuniya ("we," "our," or "us"). We are committed to protecting your privacy and ensuring you have a positive experience on our platform. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our hostel management and booking services.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  2. Information We Collect
                </h3>
                <h5 className="fw-semibold mt-3 mb-2">2.1 Personal Information</h5>
                <p>We may collect the following personal information:</p>
                <ul>
                  <li>Name, email address, phone number</li>
                  <li>Address and location data</li>
                  <li>Payment information (processed securely through third-party payment gateways)</li>
                  <li>Government-issued identification documents (for verification purposes)</li>
                  <li>Profile photographs</li>
                </ul>

                <h5 className="fw-semibold mt-3 mb-2">2.2 Usage Information</h5>
                <p>We automatically collect information about how you interact with our platform:</p>
                <ul>
                  <li>Device information (IP address, browser type, operating system)</li>
                  <li>Usage patterns and preferences</li>
                  <li>Log files and analytics data</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  3. How We Use Your Information
                </h3>
                <p>We use the collected information for the following purposes:</p>
                <ul>
                  <li>To provide and maintain our services</li>
                  <li>To process transactions and manage your account</li>
                  <li>To communicate with you about your bookings and inquiries</li>
                  <li>To improve our platform and develop new features</li>
                  <li>To send promotional materials and updates (with your consent)</li>
                  <li>To detect, prevent, and address technical issues and fraud</li>
                  <li>To comply with legal obligations</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  4. Information Sharing and Disclosure
                </h3>
                <p>We do not sell your personal information. We may share your information in the following circumstances:</p>
                <ul>
                  <li><strong>Service Providers:</strong> With third-party vendors who perform services on our behalf</li>
                  <li><strong>Business Transfers:</strong> In connection with any merger, sale, or acquisition</li>
                  <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                  <li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  5. Data Security
                </h3>
                <p>
                  We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  6. Your Rights
                </h3>
                <p>You have the right to:</p>
                <ul>
                  <li>Access and receive a copy of your personal data</li>
                  <li>Rectify inaccurate or incomplete information</li>
                  <li>Request deletion of your personal data</li>
                  <li>Object to processing of your personal data</li>
                  <li>Request restriction of processing</li>
                  <li>Data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  7. Cookies and Tracking Technologies
                </h3>
                <p>
                  We use cookies and similar tracking technologies to track activity on our platform and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  8. Third-Party Links
                </h3>
                <p>
                  Our platform may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  9. Children's Privacy
                </h3>
                <p>
                  Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  10. Changes to This Privacy Policy
                </h3>
                <p>
                  We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  11. Contact Us
                </h3>
                <p>
                  If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:
                </p>
                <p className="mb-1">
                  <strong>Email:</strong> hostelduniya24@gmail.com
                </p>
                <p className="mb-1">
                  <strong>Phone:</strong> 7678134697
                </p>
                <p>
                  <strong>Address:</strong> B-116 Rajiv Nagar Budh Bazar
                </p>
              </section>
            </div>
          </Card.Body>
        </Card>

        <div className="text-center mt-4">
          <Link
            to="/"
            className="btn fw-semibold px-4 py-2"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            style={{
              backgroundColor: "#8B0000",
              color: "white",
              borderRadius: "10px",
              textDecoration: "none",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#A00000";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#8B0000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </Container>
    </div>
  );
}

